import { Component } from '@angular/core';
import { NavController,  ViewController, Config,} from 'ionic-angular';

import { Nav, NavParams, MenuController, Events, } from 'ionic-angular';
import { RepositoryMyRadiant, UserMyRadiant as User, PermitProvider, Me, HelperMyRadiant  } from '@providers/index';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'faq-page',
  templateUrl: 'page.html'
})
export class FAQPage {
  loading : any;
  formPermit = {
    type:'',
    date:'',
    purpose:'',
  };
  parameter = {
    app:this.navParams.get('params'),
  };
  data = {
    list:[],
    content:null,
    activeShow:{
      title:'My Radiant',
    }
    
  };
  
  
  constructor(
    public navCtrl            : NavController,
    public userApi            : User,
    public menuCtrl           : MenuController,
    public nav                : Nav,
    public navParams          : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public activityProvider   : Me,
    public viewCtrl           : ViewController,
    public events             : Events,
    public config             : Config,
    public helper             : HelperMyRadiant,
    public sanitizer          : DomSanitizer,
    ) {
    this.config.set('backButtonText',"FAQ");
    this.getListFAQ(this.navParams.get('params'));
  }
  getListFAQ(modul){
    this.loading = this.helper.showLoading('Loading Data..');
    let me = this;
    this.parameter.app = modul;
    this.repositoryProvider.getListFAQ(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        if (resp.data) {
          me.data.content = this.sanitizer.bypassSecurityTrustHtml(this.helper.ifvalnull(resp.data['content'],''));
        }
      }
    },(err) => {
      this.helper.presentSwal('','Errorr','error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }  
}



// WEBPACK FOOTER //
// ./src/pages/faq/page.ts